import logoHome from 'src/assets/logo_home.svg';
import Banner from 'src/components/Banner';
import './style.scoped.css';
import homeStore, { HomeStore } from 'src/stores/HomeStore';
import { observer } from 'mobx-react-lite';

interface BannerObserverProps {
  store?: HomeStore;
}
const BannerObserver = observer((props: BannerObserverProps) => {
  const { store } = props;
  return <Banner data={store.homeBanner} />;
});

const HomeToolbar = (props) => {
  // const { onBack, title } = props;
  // const history = useHistory();
  // console.log('Banner');
  // const _handleBack = useCallback(() => {
  //   if (onBack) {
  //     onBack();
  //     return;
  //   }
  //   if (history.length >= 2) {
  //     history.goBack();
  //   }
  // }, [history, onBack]);
  //  fixed top-0 left-0 right-0
  return (
    <div className="toolbarContainer">
      {/* <div className="flex flex-row items-center justify-between relative w-full titleContainer">
        <div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center pointer-events-none">
          <div className="title m-auto">{title}</div>
        </div>
        <div className="flex items-center" onClick={_handleBack}>
          <img src={chrevronLeft} className="backIcon" />
        </div>
      </div> */}
      <div className="subContent">
        <img src={logoHome} className="logo" />
        <BannerObserver store={homeStore} />
      </div>
    </div>
  );
};

export default HomeToolbar;
